module.exports = __webpack_public_path__ + "img/0f01ffae95aca5159d85dddc7c66efe4.png";